import React, { useEffect } from "react";
import { Outlet, useNavigate } from "react-router-dom";
import useEvacuationManger from "../../../hooks/useEvacuationManager";

type Props = {};

export default function EvacuationManagerGuard({}: Props) {
  const navigate = useNavigate();
  const [isManager] = useEvacuationManger();

  useEffect(() => {
    if (isManager === undefined) return;
    else if (!isManager) {
      navigate("/evacuation/situation");
    }
  }, [isManager]);

  return <Outlet />;
}
